/**
 * DOM Utils
 *
 * @since 2018-03-29
 * @author kdydesign.kim
 */

// set element css
export function css (element, css) {
  const style = element.style

  Object.keys(css).forEach(prop => {
    style[prop] = css[prop]
  })
}

// get element offset
export function offset (el) {
  if (el === window) {
    return {top: 0, left: 0}
  }
  let {top, left} = el.getBoundingClientRect()

  return {top, left}
}
